// extracted by mini-css-extract-plugin
module.exports = {"root":"section-list_root__43O9U","item":"section-list_item__BRoT9","tick":"section-list_tick__cYrIL"};